/**
 * Consolidated string formatting and normalization utilities
 */

/**
 * Normalize a string: trim and convert to lowercase
 * @param {string} value - Value to normalize
 * @returns {string} Trimmed, lowercased string
 */
export const toLower = (value) => String(value || '').trim().toLowerCase()

/**
 * Safely convert any value to string with fallback
 * @param {*} value - Value to convert
 * @returns {string} String representation
 */
export const toStr = (value) => String(value || '')

/**
 * Format a label from underscore_separated or space-separated text
 * e.g., "shift_lead" or "shift lead" → "Shift Lead"
 * @param {string} value - Value to format
 * @returns {string} Title-cased label
 */
export const formatLabel = (value) =>
  toStr(value)
    .split(/[\s_]+/)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')
